import {useCallback, useEffect, useState} from 'react';

const PERMANENT_HIDE_KEY = 'entry-management-missions-permanent-hide';

/**
 * ミッション表示/非表示の状態管理カスタムフック
 *
 * @returns {Object} ミッション表示制御のためのオブジェクト
 * @property {boolean} isHidden - ミッションが非表示かどうか
 * @property {Function} handleClose - ミッションを閉じる関数
 * @property {boolean} isPermanentlyHidden - 永続的に非表示かどうか
 * @property {boolean} isTemporarilyHidden - 一時的に非表示かどうか
 */
export const useMissionsVisibility = () => {
  const [isTemporarilyHidden, setIsTemporarilyHidden] = useState(false);

  // localStorageから永続的な非表示フラグを読み込み（hydrationミスマッチ防止）
  const [isPermanentlyHidden, setIsPermanentlyHidden] = useState(false);
  useEffect(() => {
    try {
      setIsPermanentlyHidden(
        localStorage.getItem(PERMANENT_HIDE_KEY) === 'true',
      );
    } catch {
      // localStorage読み込みエラーは無視
    }
  }, []);

  /**
   * ミッションを閉じる処理
   * unCompletedCount === 0 の場合、localStorageに保存（永続的に非表示）
   * それ以外の場合、stateを更新（一時的に非表示）
   */
  const handleClose = useCallback((unCompletedCount: number) => {
    if (unCompletedCount === 0) {
      if (typeof window !== 'undefined') {
        try {
          localStorage.setItem(PERMANENT_HIDE_KEY, 'true');
        } catch {
          // localStorage書き込みエラーは無視
        }
      }
    }
    setIsTemporarilyHidden(true);
  }, []);

  const isHidden = isPermanentlyHidden || isTemporarilyHidden;

  return {
    isHidden,
    handleClose,
    isPermanentlyHidden,
    isTemporarilyHidden,
  };
};
